module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/feature01-485dacf28a68827388b15fa8e0eb5c4e.svg";